import { Injectable } from '@angular/core';
import { ViewColumnState } from '../../../application-controller/store/states/view-col.states';
import { ClientSidePermissionListingComponent } from '../permission-container/client-side-permission/client-side-permission-listing/client-side-permission-listing.component';
import { ClientSidePermissionAddComponent } from '../permission-container/client-side-permission/client-side-permissiont-add/client-side-permission-add.component';
import { ViewColumn } from '../../../view-column';
import { ClientSidePermissionEditComponent } from '../permission-container/client-side-permission/client-side-permissiont-edit/client-side-permission-edit.component';

@Injectable()

// This is where we need to change the view columns.
export class ClientSidePermissionPagesService {

  private initialState: ViewColumnState = {
    firstColumn: new ViewColumn(0, ClientSidePermissionListingComponent, 'Client Side Permission Listing', {
      deactivateAdd: false,
      deactivateList: false,
    }),
    secondColumn: null,
    viewCol: [
      new ViewColumn(0, ClientSidePermissionListingComponent, 'Client Side Permission Listing', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(1, ClientSidePermissionAddComponent, 'Add Client Side Permission', {
        deactivateReturn: false,
      }),
      new ViewColumn(2, ClientSidePermissionEditComponent, 'Add Client Side Permission', {
        deactivateReturn: false,
        deleteConfirmation: false
      }),
    ],
    breadCrumbs: [],
    leftDrawer: [],
    rightDrawer: [],
    singleColumn: false,
    prevIndex: null
  };

  get pages() {
    return this.initialState;
  }

  constructor() { }
}
